import { useState } from "react";
import type { InventoryUnit, AggregatedInventoryRow } from "../types";

export interface PromptState {
  title: string;
  text: string;
  variant?: "success" | "error" | "warning";
}

export interface BulkTransferTarget {
  fromEmployeeId: number;
  fromEmployeeName: string;
}

export function useWarehouseModals() {
  const [assignModal, setAssignModal] = useState<InventoryUnit | null>(null);
  const [detailsModal, setDetailsModal] = useState<number | null>(null);
  const [confirmDelete, setConfirmDelete] = useState<number | null>(null);
  const [confirmWriteOff, setConfirmWriteOff] = useState<number | null>(null);
  const [confirmReturn, setConfirmReturn] = useState<number | null>(null);
  const [prompt, setPrompt] = useState<PromptState | null>(null);
  const [transferModal, setTransferModal] = useState<InventoryUnit | null>(null);
  const [bulkTransferModal, setBulkTransferModal] = useState<BulkTransferTarget | null>(null);
  const [revalueModal, setRevalueModal] = useState<InventoryUnit | null>(null);
  const [batchDetailsModal, setBatchDetailsModal] = useState<AggregatedInventoryRow | null>(null);
  const [batchAssignModal, setBatchAssignModal] = useState<AggregatedInventoryRow | null>(null);
  const [confirmBatchWriteOff, setConfirmBatchWriteOff] = useState<AggregatedInventoryRow | null>(null);

  return {
    assignModal,
    setAssignModal,
    detailsModal,
    setDetailsModal,
    confirmDelete,
    setConfirmDelete,
    confirmWriteOff,
    setConfirmWriteOff,
    confirmReturn,
    setConfirmReturn,
    prompt,
    setPrompt,
    transferModal,
    setTransferModal,
    bulkTransferModal,
    setBulkTransferModal,
    revalueModal,
    setRevalueModal,
    batchDetailsModal,
    setBatchDetailsModal,
    batchAssignModal,
    setBatchAssignModal,
    confirmBatchWriteOff,
    setConfirmBatchWriteOff,
  };
}
